import {
  Component,
  ElementRef,
  Input,
  AfterViewInit,
  Renderer2,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core'

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: true,
})
export class TooltipComponent implements AfterViewInit {
  @Input() elementRelatedName!: string
  @Input() text!: string

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.showTooltip()
  }

  showTooltip() {
    const related = document.getElementById(this.elementRelatedName)
    if (!related) return

    const tooltip = this.el.nativeElement.querySelector('.tooltip-box') as HTMLElement
    if (!tooltip) return

    const relatedInfo = related.getBoundingClientRect()
    const tooltipInfo = tooltip.getBoundingClientRect()

    const left = relatedInfo.x - tooltipInfo.width / 2 + relatedInfo.width / 2 + 2
    this.renderer.setStyle(tooltip, 'left', `${left}px`)

    const up = relatedInfo.y > tooltipInfo.height
    if (up) {
      const top = relatedInfo.y - tooltipInfo.height - 6
      this.renderer.setStyle(tooltip, 'top', `${top}px`)
      tooltip.classList.add('top')
      tooltip.classList.remove('bottom')
    } else {
      const top = relatedInfo.y + relatedInfo.height + 6
      this.renderer.setStyle(tooltip, 'top', `${top}px`)
      tooltip.classList.add('bottom')
      tooltip.classList.remove('top')
    }

    const arrow = tooltip.querySelector('.arrow') as HTMLElement
    if (arrow) {
      const arrowLeft = tooltip.offsetWidth / 2 - 8
      this.renderer.setStyle(arrow, 'left', `${arrowLeft}px`)
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    this.showTooltip()
  }

  closeModal() {
    this.close.emit()
  }
}
